import { Tooltip } from 'components/ui/tooltip';
import { ReactNode } from 'react';

type LazyTooltipProps = {
    title: ReactNode;
    children: ReactNode;
    /** Which side of the trigger the bubble sits on. It anchors on the trigger's centre. */
    placement?: 'top' | 'bottom' | 'left' | 'right';
    /** Classes for the bubble itself. */
    contentClassName?: string;
    /** Accepted and ignored: the kit tooltip always describes its trigger. */
    describeChild?: boolean;
};

/**
 * Tooltip defaulted to the behaviour our info-source icons want: instant open on hover, and a
 * bubble that does not hold itself open when the pointer crosses it.
 *
 * The inline-flex <span> is the trigger, not the child: the icons used here are plain svg
 * components that lay out inline, and the wrapper is the hover anchor every call site's layout
 * was written around.
 */
const LazyTooltip = ({ children, title, placement = 'top', contentClassName }: LazyTooltipProps) => (
    <Tooltip content={title} delay={0} disableHoverablePopup side={placement} className={contentClassName}>
        <span className="inline-flex">{children}</span>
    </Tooltip>
);

export default LazyTooltip;
